import { render, staticRenderFns } from "./HMCanvaUpload.vue?vue&type=template&id=37d84912&scoped=true&"
import script from "./HMCanvaUpload.vue?vue&type=script&lang=ts&"
export * from "./HMCanvaUpload.vue?vue&type=script&lang=ts&"
import style0 from "./HMCanvaUpload.vue?vue&type=style&index=0&id=37d84912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d84912",
  null
  
)

export default component.exports